export default "__VITE_ASSET__CnmW5SGz__"